import { ref, onUnmounted, type Ref } from "vue";

// Shared clock — a single interval drives one reactive `now` (epoch ms) for all
// callers, so time-based UI (e.g. the floor-map "arriving soon" / "late"
// reservation ribbons) advances over time without each component spawning its
// own timer. The timer only runs while at least one component is using it.
const TICK_MS = 30_000;
let nowRef: Ref<number> | null = null;
let timer: ReturnType<typeof setInterval> | null = null;
let subscribers = 0;

export function useNow(): Ref<number> {
  // Refresh on every (re)mount: after the last subscriber unmounts the timer is
  // cleared but nowRef persists, so a later remount would otherwise show a stale
  // time until the next 30s tick.
  if (!nowRef) nowRef = ref(Date.now());
  else nowRef.value = Date.now();
  subscribers++;
  if (!timer) {
    timer = setInterval(() => {
      nowRef!.value = Date.now();
    }, TICK_MS);
  }

  onUnmounted(() => {
    subscribers = Math.max(0, subscribers - 1);
    if (subscribers === 0 && timer) {
      clearInterval(timer);
      timer = null;
    }
  });

  return nowRef;
}
